import { AppDispatch } from '../../../../redux/store'
import { getMaterialEmissionFactor, getMaterialEmissionFactorConfiguration } from './api'
import {
  materialEmissionFactorFailure,
  materialEmissionFactorRequest,
  materialEmissionFactorSuccess,
  configuration,
} from '../../../../redux/materialEmissionFactorSlice'
import { showCorrelationIdError } from '../../../../redux/correlationIdSlice'

export const fetchMaterialEmissionFactor =
  (factorId: string, replace) => async (dispatch: AppDispatch) => {
    try {
      dispatch(materialEmissionFactorRequest())
      const { data } = await getMaterialEmissionFactor(factorId)
      dispatch(materialEmissionFactorSuccess(data))
    } catch (error: any) {
      if (error.showCorrelationId) {
        dispatch(showCorrelationIdError(error.CorrelationId))
      }
      if (error.response?.status === 400) {
        replace()
      }
      dispatch(materialEmissionFactorFailure(error.message))
    }
  }

export const getConfiguration = () => async (dispatch: AppDispatch) => {
  try {
    const { data } = await getMaterialEmissionFactorConfiguration()
    dispatch(configuration(data))
  } catch (error: any) {
    if (error.showCorrelationId) {
      dispatch(showCorrelationIdError(error.CorrelationId))
    }
    dispatch(materialEmissionFactorFailure(error.message))
  }
}
